export const stripHtml = (html) => {
  if (typeof html !== 'string') {
    return ''
  }
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}
